import { css } from '@linaria/core';
import { theming } from 'styles/utils';
export const TagWrapper = "omponents__Tag__Tag_styles_ts-TagWrapper-t1bbep9l";
export const base = "omponents__Tag__Tag_styles_ts-base-b1po3rt0";
export const selected = "omponents__Tag__Tag_styles_ts-selected-s1lvi9td";

require("./Tag_styles.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./Tag_styles.ts");